import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import {useTranslation} from "react-i18next";
import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {COMM_OK} from './WsR2.js';

const TripDialog = observer((props) => {
	const gStorage = useGlobalStorage();
	const [trip1, setTrip1] = useState(gStorage.conn.user.trip1);
	const [trip2, setTrip2] = useState(gStorage.conn.user.trip2);
	const [trip3, setTrip3] = useState(gStorage.conn.user.trip3);
	const {isOpen, handleClose} = props;
	const {t} = useTranslation('obs');

	function tripSaveTrips() {
		gStorage.conn.setUserTrips(trip1, trip2, trip3);

		let _usr = JSON.parse(JSON.stringify(gStorage.conn.user));

		delete _usr.city;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'user',
			op: 'set_trips',
			data: {
				user: _usr,
			}
		};

//  		console.log('saveUser', msg);
		gStorage.conn.ws.send(msg, tripRxWs);
	}

	function tripDlgClose() {
		/* 
		 * 'Restore' to reflect the real state. Needed when user cancels 
		 *  the operation but does not hurt after succesful save either.
		 */
		setTrip1(gStorage.conn.user.trip1);
		setTrip2(gStorage.conn.user.trip2);
		setTrip3(gStorage.conn.user.trip3);

		handleClose();
	}

	function tripRxWs(status, obj) {
		if (status !== COMM_OK) {
			console.error('tripRxWs: error ', status);
			return -1;
		}

		if (obj.cmd === 'user') {
			if (obj.op === 'set_trips') {
				if (obj.result === 'OK') {
// 					console.log('tripRxWs: user save OK');
					tripDlgClose();
				} else {
					console.error('tripRxWs:', obj.cmd, obj.op, 'failed!');
				}
			} else {
				console.error('tripRxWs: unknown operation', obj.cmd, obj.op, obj.result);
			}
		} else {
			console.error('tripRxWs: invalid command', obj.cmd);
			return -1;
		}
	}

	function tripList1() {
		let ret = [];

		gStorage.lists.triplist.list.forEach((trip, ind) => {
			if (trip.public_trip && trip.active && (trip.id === 0 || (trip.id !== trip2 && trip.id !== trip3))) {
				ret.push(<MenuItem key={trip.id} value={trip.id}>{t(trip.name)}</MenuItem>);
			}
		});

// 		console.log('tripList1', ret, gStorage.conn.user.trip1, trip1);

		return ret;
	}

	function tripChange1(event) {
// 		console.log('tripChange1', event.target.value);
		setTrip1(parseInt(event.target.value, 10));
	}

	function tripList2() {
		let ret = [];

		gStorage.lists.triplist.list.forEach((trip, ind) => {
			if (trip.public_trip && trip.active && (trip.id === 0 || (trip.id !== trip1 && trip.id !== trip3))) {
				ret.push(<MenuItem key={trip.id} value={trip.id}>{t(trip.name)}</MenuItem>);
			}
		});

		return ret;
	}

	function tripChange2(event) {
		setTrip2(parseInt(event.target.value, 10));
	}

	function tripList3() {
		let ret = [];

		gStorage.lists.triplist.list.forEach((trip, ind) => {
			if (trip.public_trip && trip.active && (trip.id === 0 || (trip.id !== trip1 && trip.id !== trip2))) {
				ret.push(<MenuItem key={trip.id} value={trip.id}>{t(trip.name)}</MenuItem>);
			}
		});

		return ret;
	}

	function tripChange3(event) {
		setTrip3(parseInt(event.target.value, 10));
	}

	return (
        	<Dialog onClose={tripDlgClose} aria-labelledby="simple-dialog-title" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('add.active_trips')}</Typography>
						<IconButton edge="start" color="inherit" onClick={tripDlgClose} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small">
						<InputLabel>{t('trips.trip1')}</InputLabel>
						<Select
							value={trip1}
							onChange={tripChange1}
							style={{width: 284, margin: 4}}>
								{tripList1()}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small">
						<InputLabel>{t('trips.trip2')}</InputLabel>
						<Select
							value={trip2}
							onChange={tripChange2}
							style={{width: 284, margin: 4}}>
								{tripList2()}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small">
						<InputLabel>{t('trips.trip3')}</InputLabel>
						<Select
							value={trip3}
							onChange={tripChange3}
							style={{width: 284, margin: 8}}>
								{tripList3()}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Button 
						variant="contained" 
						color="primary" 
						size="small" 
						style={{width:143, margin: 4, align: 'center'}} 
						onClick={tripSaveTrips}>{t('add.save')}
					</Button>
				</Grid>
			</Grid>
		</Dialog>
	);
});

export default TripDialog;
